webpackJsonp([27078869090181],{

/***/ 1819:
/***/ (function(module, exports) {

	module.exports = {"data":{"allMarkdownRemark":{"totalCount":2,"edges":[{"node":{"fields":{"slug":"/news/5-things-you-need-to-know-if-you-are-a-designer/"},"frontmatter":{"title":"5 things you need to know if you are a designer.","templateKey":"news","thumb":{"responsive":{"childImageSharp":{"original":{"src":"/static/1160x450 5 things james article header image v1-c594e7690c774b140c022e6ff7b08b25.jpg"}}},"original":"/img/1160x450 5 things james article header image v1.jpg"},"category":"Insight"}}},{"node":{"fields":{"slug":"/news/five-things-you-know-if-you-are-an-account-manager/"},"frontmatter":{"title":"5 Things You Should Know If You Are An Account Manager","templateKey":"news","thumb":{"responsive":{"childImageSharp":{"original":{"src":"/static/1160x450-hannah-5-article-header-image-v1-86bb0e14855e3b82f9e73a5530287317.jpg"}}},"original":"/img/1160x450-hannah-5-article-header-image-v1.jpg"},"category":"Insight"}}}]}},"pathContext":{"tag":"insight"}}

/***/ })

});


// WEBPACK FOOTER //
// path---tags-insight-527e17a7b8422c9940b5.js